import './Normalize.css';const o = "Normalize-module__normalize___NeX1V", e = {
  normalize: o
};
export {
  e as n
};
